<div class="viewer-panel__stats viewer-panel__stats--debug">
  <div class="viewer-panel__subtitle">Scene debug</div>
  <div class="viewer-panel__actions">
    <input type="button" class="demo-button viewer-panel__button" value="Copy" (tap)="viewer.copySceneDebug()" />
    <input
      type="button"
      class="demo-button viewer-panel__button"
      value="Copy as JSON"
      (tap)="viewer.copySceneDebugAsJson()"
    />
  </div>
  <ng-container *ngIf="viewer.viewerProfilerSnapshot.mode !== 'off'">
    <div class="viewer-panel__subtitle">Profiler: {{ viewer.viewerProfilerSnapshot.mode }}</div>
    <div class="viewer-panel__state">
      Frames: {{ viewer.viewerProfilerSnapshot.frameCount }}; slow:
      {{ viewer.viewerProfilerSnapshot.slowFrameCount }}
    </div>
    <div class="viewer-panel__state">
      Long tasks:
      {{ viewer.viewerProfilerSnapshot.longTaskCount }}
      ({{ viewer.viewerProfilerSnapshot.longTaskTotalMs | number: '1.0-1' }} ms)
    </div>
    <div class="viewer-panel__state">
      GPU timer:
      {{ viewer.viewerProfilerSnapshot.gpuTimerSupported ? 'available' : viewer.viewerProfilerSnapshot.gpuTimerMessage }}
    </div>
    <div class="viewer-panel__profiler-phase" *ngFor="let phase of viewer.viewerProfilerSnapshot.phases">
      <span>{{ phase.name }}</span>
      <span> p95 {{ phase.p95Ms | number: '1.1-1' }} ms / max {{ phase.maxMs | number: '1.1-1' }} ms </span>
    </div>
    <div class="viewer-panel__subtitle">Counters (latest / average)</div>
    <div class="viewer-panel__profiler-phase" *ngFor="let counter of viewer.viewerProfilerSnapshot.counters">
      <span>{{ counter.name }}</span>
      <span> last {{ counter.last | number: '1.0-1' }} / avg {{ counter.average | number: '1.0-1' }} </span>
    </div>
    <div class="viewer-panel__subtitle">Frustum trace (latest)</div>
    <div class="viewer-panel__profiler-phase" *ngFor="let event of viewer.viewerProfilerSnapshot.events.slice(-12)">
      <span>{{ event.timestampMs | number: '1.0-1' }} {{ event.name }}</span>
      <span>{{ event.detail }}</span>
    </div>
    <div class="viewer-panel__actions">
      <button type="button" class="demo-button viewer-panel__button" (click)="viewer.resetViewerProfiler()">
        Reset profiler
      </button>
    </div>
  </ng-container>
  <div class="viewer-panel__state">Queued objects: {{ viewer.sceneStats.queueObjectsCount }}</div>
  <div class="viewer-panel__state">Frustum visible: {{ viewer.sceneStats.frustumVisibleObjectsCount }}</div>
  <div class="viewer-panel__state">Frustum sorted: {{ viewer.sceneStats.frustumSortedObjectsCount }}</div>
  <div class="viewer-panel__state">Frustum culling ms: {{ viewer.sceneStats.frustumCullingMs | number: '1.2-2' }}</div>
  <div class="viewer-panel__state">
    Camera position: {{ viewer.cameraPositionDebug[0] | number: '1.2-2' }},
    {{ viewer.cameraPositionDebug[1] | number: '1.2-2' }},
    {{ viewer.cameraPositionDebug[2] | number: '1.2-2' }}
  </div>
  <div class="viewer-panel__actions">
    <button type="button" class="demo-button viewer-panel__button" (click)="viewer.toggleCameraPathRecording()">
      {{ viewer.cameraPathRecording ? 'Stop and download camera path (' + viewer.cameraPathRecordedKeys + ' keys)' : 'Record camera path' }}
    </button>
  </div>
  <div class="viewer-panel__state">Load mode: {{ viewer.sceneLoadDebug.loadMode }}</div>
  <div class="viewer-panel__state">
    Total scene objects: {{ viewer.sceneLoadDebug.totalSceneObjectsCount | number }}
  </div>
  <div class="viewer-panel__state">
    Geometry IDs: {{ viewer.sceneLoadDebug.meshIdsCount }} meshes, {{ viewer.sceneLoadDebug.lineIdsCount }} lines,
    {{ viewer.sceneLoadDebug.pointCloudIdsCount }} clouds
  </div>
  <div class="viewer-panel__state">
    Decoded: {{ viewer.sceneLoadDebug.decodedMeshesCount }} meshes, {{ viewer.sceneLoadDebug.decodedLinesCount }} lines,
    {{ viewer.sceneLoadDebug.decodedPointCloudsCount }} clouds
  </div>
  <div class="viewer-panel__state">
    Loaded geometry: {{ viewer.sceneGeometryDebug.loadedMeshGeometriesCount | number }} meshes,
    {{ viewer.sceneGeometryDebug.loadedTrianglesCount | number }} triangles,
    {{ viewer.sceneGeometryDebug.loadedLineSegmentsCount | number }} line segments,
    {{ viewer.sceneGeometryDebug.loadedPointsCount | number }} points
  </div>
  <div class="viewer-panel__state">
    Decoded mesh cache: {{ viewer.sceneCacheBudgetDebug.meshBytes / 1048576 | number: '1.1-1' }} /
    {{ viewer.sceneCacheBudgetDebug.meshBudgetBytes / 1048576 | number: '1.0-0' }} MiB ({{ viewer.sceneCacheBudgetDebug.meshCount | number }}
    entries)
  </div>
  <div class="viewer-panel__state">
    Texture cache: {{ viewer.sceneCacheBudgetDebug.textureBytes / 1048576 | number: '1.1-1' }} /
    {{ viewer.sceneCacheBudgetDebug.textureBudgetBytes / 1048576 | number: '1.0-0' }} MiB ({{ viewer.sceneCacheBudgetDebug.textureCount | number }}
    textures)
  </div>
  <div class="viewer-panel__hint">Estimated cache sizes; visible assets may exceed the budgets.</div>
  <div *ngIf="viewer.hlodDebug" class="viewer-panel__state">{{ viewer.hlodDebug }}</div>
  <div class="viewer-panel__state">
    Rendered: {{ viewer.ingestState.renderedMeshObjectsCount }} meshes,
    {{ viewer.ingestState.renderedLineObjectsCount }} lines,
    {{ viewer.ingestState.renderedPointCloudObjectsCount }} clouds
  </div>
  <div class="viewer-panel__state">
    Payload:
    {{ viewer.sceneLoadDebug.meshesBinaryBytes + viewer.sceneLoadDebug.linesBinaryBytes + viewer.sceneLoadDebug.pointCloudsBinaryBytes }}
    bytes
  </div>
  <div class="viewer-panel__state">
    Rejected meshes:
    {{ viewer.sceneLoadDebug.meshRejectedInvalidVertices + viewer.sceneLoadDebug.meshRejectedEmptyIndices + viewer.sceneLoadDebug.meshRejectedInvalidIndices + viewer.sceneLoadDebug.meshRejectedIndexedBuildFailed + viewer.sceneLoadDebug.meshRejectedRegularFallbackFailed }}
  </div>
  <div class="viewer-panel__state">Updated: {{ viewer.sceneLoadDebug.lastUpdatedAt }}</div>
  <div class="viewer-panel__state">Last error: {{ viewer.sceneLoadDebug.lastError }}</div>
  <div class="viewer-panel__state">
    Visual quality: {{ viewer.visualQualitySettings.profile }}; AA {{ viewer.visualQualitySettings.antiAliasing }}
  </div>
  <div *ngIf="viewer.visualQualityDiagnosticMessage" class="viewer-panel__state">
    Visual quality diagnostic: {{ viewer.visualQualityDiagnosticMessage }}
  </div>
  <div class="viewer-panel__state">
    Effects:
    {{ viewer.visualQualitySettings.specularEnabled ? 'specular ' : '' }}
    {{ viewer.visualQualitySettings.fresnelEnabled ? 'fresnel ' : '' }}
    {{ !viewer.visualQualitySettings.specularEnabled && !viewer.visualQualitySettings.fresnelEnabled ? 'none' : '' }}
  </div>
  <div class="viewer-panel__state">
    Current camera draw calls (estimated full redraw): {{ viewer.sceneRenderTotals.drawCalls | number }}; active scene
    triangles:
    {{ viewer.sceneRenderTotals.triangles | number }}
  </div>
  <div class="viewer-panel__state">
    Instanced batches: {{ viewer.sceneRenderTotals.instancedDrawCalls | number }}/{{
      viewer.sceneRenderTotals.totalInstancedBatches | number
    }}
    visible; culled: {{ viewer.sceneRenderTotals.culledInstancedBatches | number }}
  </div>
  <div class="viewer-panel__state">
    Instanced draw calls: {{ viewer.sceneRenderTotals.instancedDrawCalls | number }}; instances:
    {{ viewer.sceneRenderTotals.instancedInstances | number }}
  </div>
  <div class="viewer-panel__state">Shader builds (cumulative): {{ viewer.visualQualityShaderBuildCount }}</div>
  <div class="viewer-panel__state">Cached shader programs: {{ viewer.sceneCachedShaderPrograms }}</div>
  <div class="viewer-panel__state">
    Distributed rendering: {{ viewer.sceneStats.distributedRendering ? 'on' : 'off' }}
  </div>
  <div class="viewer-panel__state">Clipping: {{ viewer.sceneStats.clippingEnabled ? 'on' : 'off' }}</div>
  <div class="viewer-panel__state">Measurement mode: {{ viewer.sceneStats.measurementEnabled ? 'on' : 'off' }}</div>
</div>
